import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function CoachCodePreview({ preview, checking, codeLength = 0, minLength = 7 }) {
  if (checking) {
    return (
      <p className="mt-2 text-sm text-slate-500 flex items-center gap-1.5" data-testid="coach-code-checking">
        <Loader2 className="w-3.5 h-3.5 animate-spin" />
        Vérification du code...
      </p>
    );
  }

  if (preview?.valid) {
    return (
      <p
        className="mt-2 text-sm text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-lg px-3 py-2 flex items-start gap-2"
        data-testid="coach-code-valid"
      >
        <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0" />
        <span>
          Vous serez associé à <strong>{preview.name}</strong>
          {preview.pseudo ? <> (@{preview.pseudo})</> : null}
        </span>
      </p>
    );
  }

  if (preview?.valid === false && codeLength >= minLength) {
    return (
      <p
        className="mt-2 text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2 flex items-center gap-2"
        data-testid="coach-code-invalid"
      >
        <XCircle className="w-4 h-4 shrink-0" />
        Code coach introuvable
      </p>
    );
  }

  return null;
}